module.exports = __webpack_public_path__ + "img/tv.93e29633.svg";